export enum TeamsAction {
    UPDATE_TEAMS_STANDINGS = 'UPDATE_TEAMS_STANDINGS'
  }
  
  export type TeamsType = {
    teamName: string;
    teamAbbrName: string;
    teamNick: string;
    teamId: string;
    divAbbrName: string;
    confAbbrName: string;
    divFullName: string;
    totalWins: number;
    totalLoss: number;
    totalTies: number;
    divTotalWins: number;
    divTotalLoss: number;
    divTotalTies: number;
    totalGamesPlayed: number;
    winPercentage: number;
    pointsFor: number;
    pointsAgainst: number;
    perfStatsLoaded: boolean;
    divStand: string;
  }
export type ConferenceType = {
    [teamId: string]: TeamsType;

};
export type TeamsResponse = {

    AFC: ConferenceType;
    NFC: ConferenceType // "AFC", "NFC", etc.

};

  
  interface UpdateTeamsData {
    type: TeamsAction.UPDATE_TEAMS_STANDINGS,
    teams: ConferenceType,
  }
  
  export type UpdateTeamsActionTypes = UpdateTeamsData;